import { Box, CircularProgress, styled } from '@mui/material';
import FolderOpenOutlinedIcon from '@mui/icons-material/FolderOpenOutlined';
import FolderOffOutlinedIcon from '@mui/icons-material/FolderOffOutlined';

export const Archive = styled(FolderOpenOutlinedIcon)({
  color: 'rgba(0, 0, 0, 0.7)',
});

export const Desarchive = styled(FolderOffOutlinedIcon)({
  color: 'rgba(0, 0, 0, 0.7)',
});

export const BoxArchive = styled(Box)({
  display: 'flex',
  justifyContent: 'center',
  border: 'none',
  background: 'none',
  margin: '0 auto',
  padding: '0',
  '&:hover': {
    cursor: 'pointer',
    background: 'none',
  },
  transform: 'scale(1.6)',
});

export const Loading = styled(CircularProgress)({
  border: 'none',
  background: 'none',
  margin: '0 auto',
  padding: '0',
  '&:hover': {
    cursor: 'pointer',
  },
  '&:focus': {
    cursor: 'pointer',
    outline: 'none',
    background: 'none',
  },
});
